import * as React from 'react';

// Pass the `isLoading` value to the hook in order to ensure that
// the request has been triggered at least once

// Btw. Really usefull
export const useInitialLoaderCondition = (relatableLoadingState: boolean) => {
  const [initialLoadingState, setInitialLoadingState] = React.useState<{
    isInitialLoadingFinished: boolean;
    lastLoaderValue: boolean;
  }>({
    isInitialLoadingFinished: false,
    lastLoaderValue: false,
  });

  React.useEffect(() => {
    const { isInitialLoadingFinished, lastLoaderValue } = initialLoadingState;
    if (!isInitialLoadingFinished) {
      if (!relatableLoadingState && lastLoaderValue) {
        setInitialLoadingState({
          isInitialLoadingFinished: true,
          lastLoaderValue: relatableLoadingState,
        });
      } else {
        setInitialLoadingState({
          isInitialLoadingFinished,
          lastLoaderValue: relatableLoadingState,
        });
      }
    }
  }, [relatableLoadingState]);

  return initialLoadingState.isInitialLoadingFinished;
};
